/**
 * The one place the relatives portal leaves its own origin.
 *
 * It exists as a module rather than an inline `window.location.assign` so the
 * hand-off to the payment provider is a seam: the buy flow can be tested without
 * a jsdom navigation, and there is exactly one line to audit when asking "where
 * can this app send a relative?".
 */
export function leaveTo(url: string): void {
  // A full navigation, never an iframe. The provider's page has to be able to
  // show the browser's own address bar and padlock - that is most of what makes
  // a stranger's card form trustworthy to the person filling it in.
  window.location.assign(url);
}
